let cardsLoad = setInterval(() => {
  let elemnts = document.querySelectorAll('.card__color-swatch').length;
  if (elemnts > 0) {
    clearInterval(cardsLoad);
    document.querySelectorAll('.card__color-swatch').forEach(el => {
      el.addEventListener('click',function(){
        this.parentElement.querySelectorAll('.card__color-swatch').forEach( item =>{
          item.classList.remove('active')
        })
        this.classList.add('active');
        let cardImageWrapper = el.parentElement.parentElement.parentElement;
        let varImage = el.dataset.img;
        if (varImage) {
          cardImageWrapper.querySelector('.card__media img').srcset = varImage;
        }
      })
    })
  }
}, 500);
